<template>
  <UiComponentContainer
    :end="0"
    :start="0"
    class="blog-posts-list"
  >
    <UiComponentWrapper class="blog-posts">
      <UiComponentWrapper>
        <MoleculeBlogPost
          v-for="(post, index) in blogPosts"
          :key="post.id"
          :lazyload="index > 0"
          :level="level"
          :minutes-read="props.minutesRead"
          :post="post"
        />
      </UiComponentWrapper>
    </UiComponentWrapper>
    <MoleculePagination
      v-if="numberOfPages > 1"
      :count="numberOfPages >= 1 ? numberOfPages : 1"
      :folder-name="folderName"
      :root="root"
      :value="activePage"
    />
  </UiComponentContainer>
</template>

<script setup>
// Props
const props = defineProps({
  activePage: {
    default() {
      return 1
    },
    type: Number,
    required: false,
  },
  blogPosts: {
    required: true,
    type: Array,
  },
  folderName: {
    required: true,
    type: String,
  },
  level: {
    default() {
      return 3
    },
    required: false,
    type: Number,
    validator(value) {
      return [2, 3].indexOf(value) !== -1
    },
  },
  minutesRead: {
    default() {
      return 'min. read'
    },
    required: true,
    type: String,
  },
  numberOfPages: {
    required: true,
    type: Number,
  },
  root: {
    required: true,
    type: String,
  },
})
</script>

<style lang="postcss" scoped>
.blog-posts-list {
  @apply flex-col;

  @screen md {
    @apply mt-26 pt-10 bg-transparent;
  }

  .blog-posts {
    @apply mt-8 flex-col;

    @screen md {
      @apply mt-0;
    }

    &.second {
      @apply mt-3;

      @screen md {
        @apply mt-16;
      }
    }

    h3 {
      @apply font-medium text-grey-blue-900;

      @screen md {
        @apply text-3xl leading-10;
      }
    }

    p {
      @apply mt-4 text-grey-blue-600;
    }

    .wrapper {
      @apply flex-col;

      @screen md {
        @apply flex-row flex-wrap;
      }

      .blog-post {
        @apply mt-12;

        @screen md {
          @apply mt-16;
          width: calc(50% - 20px);
        }

        @screen xl {
          @apply ml-10 w-100;
        }

        &:first-child {
          @apply mt-0;

          @screen md {
            @apply mt-10;
          }
        }

        &:nth-child(2) {
          @screen md {
            @apply mt-10;
          }
        }

        &:nth-child(3) {
          @screen xl {
            @apply mt-10;
          }
        }

        &:nth-child(2n) {
          @screen md {
            @apply ml-10;
          }
        }

        &:nth-child(3n + 1) {
          @screen xl {
            @apply ml-0;
          }
        }
      }
    }
  }

  .pagination {
    @apply mt-16;

    :deep(.button) {
      @apply text-sm leading-6;
    }
  }
}
</style>
